import { type PathKey } from '~/apps/applicationAdmin/routes/paths'

export const pathKey = 'brandAccountsList' satisfies PathKey

export const isLessThan = (value: number, threshold: number): boolean =>
  value < threshold
